// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__ihb-k","title":"FrontImage_title__2p4Ux"};